import { IAuthState } from 'src/interface';

export const ACTIONS = {
    AUTH_SET_STATE: 'AUTH_SET_STATE',
    AUTH_IS_FETCHING_UPDATE: 'AUTH_IS_FETCHING_UPDATE',
    AUTH_CLEAR_STATE: 'AUTH_CLEAR_STATE',
}

export const setAuthState = (authState: IAuthState) => ({
    type: ACTIONS.AUTH_SET_STATE,
    payload: authState,
});

export const clearAuthState = () => ({
    type: ACTIONS.AUTH_CLEAR_STATE,
});

export const isFetchingUpdate = (isFetching: boolean) => ({
    type: ACTIONS.AUTH_IS_FETCHING_UPDATE,
    payload: isFetching,
});
